export default __webpack_public_path__ + "static/media/purple_mark_icon.d4cbe45a.svg";